import React from 'react';


class Text extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <input className="form-control" />
            </div>
        );
    }


}

export default Text;




// WEBPACK FOOTER //
// ./containers/segments/Rules/Text.js